import { render, staticRenderFns } from "./BlockedCaptains.vue?vue&type=template&id=d24ce3ba&scoped=true"
import script from "./BlockedCaptains.vue?vue&type=script&lang=js"
export * from "./BlockedCaptains.vue?vue&type=script&lang=js"
import style0 from "./BlockedCaptains.vue?vue&type=style&index=0&id=d24ce3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24ce3ba",
  null
  
)

export default component.exports